// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hYYR","content":"styles_content__2L3q8","row":"styles_row__zq_CD","footer":"styles_footer__2Q8fZ","phraseLength":"styles_phraseLength__2E9mv"};